/* ============
 * Bill Transformer
 * ============
 *
 * The transformer for the Bill.
 */

import Transformer from './transformer';
import clientTransformer from './client';

export default class BillTransformer extends Transformer {

  static fetch(bill) {
    if (bill.country) bill.bill_address.country = bill.country;
    return {
      id: bill.id,
      hashid: bill.hashid,
      totalValue: bill.total_value,
      totalQuantity: bill.total_quantity,
      roundInvoiceTotal: bill.round_invoice_total,
      orderId: bill.order_id,
      billStatusId: bill.bill_status_id,
      billStatus: bill.bill_status,
      billTypeId: bill.bill_type_id,
      billType: bill.bill_type,
      creditNoteSource: bill.credit_note_source,
      creditNotes: bill.credit_notes,
      creditNoteValue: bill.credit_note_value,
      creditNoteReason: bill.credit_note_reason,
      billingNumber: bill.billing_number,
      client: (typeof bill.client === 'object') ? clientTransformer.fetch(bill.client) : bill.client,
      dueDate: bill.due_date,
      paymentDate: bill.payment_date,
      date: bill.date,
      paymentMessage: bill.paymentMessage,
      kidNumber: bill.kid_number,
      note: bill.note,
      sourceBillNumber: bill.source_billing_number,
      billAddressStreetName: bill.bill_address_street_name,
      billAddressSecondStreetName: bill.bill_address_second_street_name,
      billAddressPostalCode: bill.bill_address_postal_code,
      billAddressCityName: bill.bill_address_city_name,
      billSentAt: bill.bill_sent_at,
      updatedAt: bill.updated_at,
      storeName: bill.store_name,
      creditNoteReasonId: bill.credit_note_reason_id, // For credit note reason
      billAddressMissing: bill.bill_address_missing,
      billAddress: bill.bill_address,
      clientId: bill.client_id,
      billProducts: bill.bill_products,
      summaryGrouping: bill.summary_grouping,
      emailCopy: bill.email_copy,
      amountDue: bill.amount_due,
      amountPaid: bill.amount_paid,
      totalGross: bill.total_gross,
      ediOrderError: bill.edi_order_error,
      sendVia: bill.send_via,
      language: bill.language,
      languageId: bill.language_id,
      currency: bill.currency,
      currencyId: bill.currency_id,
      billReminders: bill.bill_reminders,
      latestBillReminder: bill.latest_bill_reminder,
      penaltyFees: bill.penalty_fees,
      canCreateReminderWithFee: bill.can_create_reminder_with_fee,
      reminderFeesTotalAmount: bill.reminder_fees_total_amount,
      reminderWithFeeWarning: bill.reminder_with_fee_warning,
    };
  }

  static send(bill) {
    return {
      id: bill.id,
      hashid: bill.hashid,
      order_id: bill.orderId,
      round_invoice_total: bill.roundInvoiceTotal,
      bill_status_id: bill.billStatusId,
      bill_type_id: bill.billTypeId,
      credit_note_source: bill.creditNoteSource,
      credit_note_value: bill.creditNoteValue,
      credit_note_reason: bill.creditNoteReason,
      due_date: bill.dueDate,
      payment_date: bill.paymentDate,
      date: bill.date,
      kid_number: bill.kidNumber,
      paymentMessage: bill.paymentMessage,
      note: bill.note,
      updated_at: bill.updatedAt,
      credit_note_reason_id: bill.creditNoteReasonId, // For credit note reason
      summary_grouping: bill.summaryGrouping,
      language_id: bill.languageId,
      currency_id: bill.currencyId,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/bill.js